import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const builtFor = ['Competitors who hate losing', 'Former athletes with a chip on their shoulder', 'People hungry to grow and improve', 'Coachable individuals who take feedback', 'Those with grit and resilience', 'People ready to bet on themselves'];
const notFor = ['People looking to clock in and coast', "Those who can't handle pressure", 'People who fold when it gets hard', 'Those resistant to coaching', 'Anyone expecting easy money', 'People who make excuses'];
export function WhoThrives() {
  return <section className="py-20 bg-charcoal" data-id="element-151">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-153">
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white mb-6" data-id="element-154">
            This isn't for everyone.
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto italic" data-id="element-155">
            "If you've ever been on a championship team or pushed yourself to
            beat a personal best, you already know how to handle pressure, how
            to take coaching, and how to show up even when it's hard."
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-156">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white/5 border-2 border-maroon rounded-xl p-8" data-id="element-157">
            <div className="flex items-center space-x-3 mb-6" data-id="element-158">
              <div className="w-10 h-10 bg-maroon rounded-full flex items-center justify-center" data-id="element-159">
                <CheckIcon className="w-6 h-6 text-white" data-id="element-160" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-161">Built For</h3>
            </div>
            <ul className="space-y-4" data-id="element-162">
              {builtFor.map((item, index) => <li key={index} className="flex items-start space-x-3" data-id="element-163">
                  <CheckIcon className="w-5 h-5 text-maroon flex-shrink-0 mt-0.5" data-id="element-164" />
                  <span className="text-gray-300" data-id="element-165">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-white/5 border-2 border-gray-700 rounded-xl p-8" data-id="element-166">
            <div className="flex items-center space-x-3 mb-6" data-id="element-167">
              <div className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center" data-id="element-168">
                <XIcon className="w-6 h-6 text-white" data-id="element-169" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-170">Not For</h3>
            </div>
            <ul className="space-y-4" data-id="element-171">
              {notFor.map((item, index) => <li key={index} className="flex items-start space-x-3" data-id="element-172">
                  <XIcon className="w-5 h-5 text-gray-500 flex-shrink-0 mt-0.5" data-id="element-173" />
                  <span className="text-gray-400" data-id="element-174">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}